import React, { Component } from 'react'
import Reveal from 'react-reveal/Reveal';

class CompetenceItem extends Component {

    onMouseOver = () => {
        this.props.onHover(this.props.index);
    }

    render() {
        let vsrc = this.props.item.icon + ".png";
        return (
            <div 
                className={this.props.className}
                onMouseOver={() => this.props.onHover(this.props.index)}  
                >
                    <li  className="competences_list-element">
                        <div className="competences_list-element-icon-div"><img className="competences_list-element-icon" src={vsrc}  alt={"logo"} /></div>
                        <h4 className="competences_list-element-title">{this.props.item.name}</h4> 
                    </li>

            </div>
        )
    }
}

export default CompetenceItem;


// WEBPACK FOOTER //
// ./src/components/containers/CompetenceItem.js